import { render, staticRenderFns } from "./DisplayPrint.vue?vue&type=template&id=efad6986&"
import script from "./DisplayPrint.vue?vue&type=script&lang=js&"
export * from "./DisplayPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports